<section id="Bx-toast-area">
  <div class="overlay-container">
    <!-- General Container -->
    <div
      id="toast-container"
      class="toast-top-right toast-container"
      [class.is-collapsable] = "isCollapsable">
      <!-- action div, activated when containing two or more toasts -->
      <div class="ngx-toastr notifications-area"
        *ngIf="toasts?.length >= 2">
        <div class="title-actions">
          <!-- Title actions -->
          <h6 class="title">Alarmas</h6>
          <!-- Buttons actions -->
          <div class="actions">
            <button
              mat-icon-button
              class="btn-collapsable"
              matTooltip="Ocultar notificaciones"
              (click)="collapsable()"
              color="accent">
                <mat-icon>vertical_split</mat-icon>
            </button>
            <button
            mat-icon-button
            matTooltip="Borrar notificaciones"
            (click)="removeAll()"
            color="secondary">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
      <!-- For to each Toast -->
      <div (click)="remove(toast.id, i);"
      *ngFor="let toast of toasts; index as i"
      [class.no-title] = "!toast?.title"
      [class.is-delete] = "toasts[i]?.isActive"
      class="ngx-toastr toast-{{toast.type}}">
        <!-- Toast title-->
        <div class="toast-title text-lg my-2">
          <mat-icon
            aria-hidden="true"
            aria-label="home icon"
            fontIcon="{{typesIcons[toast.type]}}">
          </mat-icon> 
          {{toast.title}}
        </div>
        <!-- Toast message -->
        <p class="toast-message">{{toast.message}}</p>
        <!-- Toast close button -->
        <a class="close" (click)="remove(toast.id, i)">&times;</a>
      </div>
    </div>
  </div>
</section>